/*
*
* PANIER JS
*
*/
function openModaleCS($message){

	$('#modal-c-s .modal-body').html($message);
	$('#modal-c-s').modal('show');
	window.lazyLoadInstance.update()
}

function closeModaleCS(){

	$('#modal-c-s .modal-body').html();
	$('#modal-c-s').modal('hide');
}

$(document).ready(function() {

/**
 * Sur etape4, autovalidation du paiement
 */
	if( $('#autoValidateFormBank').length > 0 ){

		//simulation d'un truc sérieux et compliqué, on redirige au bout de quelques secondes
		setTimeout( function(){
			$('#autoValidateFormBank').submit();
		}, 2000 );
	}



	$('body').on('click', '.btn.ajouter-produit', function(e) {

		e.preventDefault();
		var form = $(this).closest('form');

		$.ajax({
			url: form.attr('action'),
			type: 'POST',
			dataType: 'json',
			data: form.serialize()
		})
  	.done(function(data) {

			openModaleCS(data.message);
			$('.cart-container .number-in-cart').html(data.quantity);
		})
		.fail(function(jqXHR) {
			/*cleanModal($('#modal-c-s'));
			form.find('.modal-body').prepend('<div class="alert alert-danger mt-2 mb-4">' + (jqXHR.status == 419 ? Lang._i('ajax.message.page_expiree') : Lang._i('ajax.message.erreur')) + '</div>');
			enableElements(btn);*/
		});

	});

	$('#choix-livraison .js-adresse').on('click', function(e) {
        e.preventDefault();
        var formUrl = $(this).attr("href");

        $.ajax({
			url: formUrl,
			type: 'GET',
			dataType: 'json'
		})
  	    .done(function(data) {

			openModaleCS(data.message);
		})
		.fail(function(jqXHR) {
			/*cleanModal($('#modal-c-s'));
			form.find('.modal-body').prepend('<div class="alert alert-danger mt-2 mb-4">' + (jqXHR.status == 419 ? Lang._i('ajax.message.page_expiree') : Lang._i('ajax.message.erreur')) + '</div>');
			enableElements(btn);*/
        });
    });

	$('body').on('click', '.btn-adresse-livraison', function(e) {
        e.preventDefault();
		var form = $(this).closest('form');

		$.ajax({
			url: form.attr('action'),
			type: 'POST',
			dataType: 'json',
			data: form.serialize()
		})
  	    .done(function(data) {
			closeModaleCS();
			location.reload();
		})

		.fail(function(data) {
			if( data.status === 422 )
			{
				var errors = $.parseJSON(data.responseText);
				$.each(errors, function (key, value) {
					if($.isPlainObject(value)) {
						$.each(value, function (key, value) {				
							$('#adresseLivraisonForm #'+key).addClass("is-invalid");
							if( $('#adresseLivraisonForm #'+key).next().hasClass('invalid-feedback') == false) {
								$('#adresseLivraisonForm #'+key).after( '<div class="invalid-feedback d-block">' + value + '</div>');
							}
						});
					}else{
						$('#adresseLivraisonForm #'+key).addClass("is-invalid");
						if( $('#adresseLivraisonForm #'+key).next().hasClass('invalid-feedback') == false) {
							$('#adresseLivraisonForm #'+key).after( '<div class="invalid-feedback d-block">' + value + '</div>');
						}
					}
				});
			}
		});
	});
	

	$('body').on('click', '.btn-adresse-facturation', function(e) {
        e.preventDefault();
		var form = $(this).closest('form');

		$.ajax({
			url: form.attr('action'),
			type: 'POST',
			dataType: 'json',
			data: form.serialize()
		})
  	    .done(function(data) {
			closeModaleCS();
			location.reload();
		})

		.fail(function(data) {
			if( data.status === 422 )
			{
				var errors = $.parseJSON(data.responseText);
				$.each(errors, function (key, value) {
					if($.isPlainObject(value)) {
						$.each(value, function (key, value) {				
							$('#adresseFacturationForm #'+key).addClass("is-invalid");
							if( $('#adresseFacturationForm #'+key).next().hasClass('invalid-feedback') == false) {
								$('#adresseFacturationForm #'+key).after( '<div class="invalid-feedback d-block">' + value + '</div>');
							}
						});
					}else{
						$('#adresseFacturationForm #'+key).addClass("is-invalid");
						if( $('#adresseFacturationForm #'+key).next().hasClass('invalid-feedback') == false) {
							$('#adresseFacturationForm #'+key).after( '<div class="invalid-feedback d-block">' + value + '</div>');
						}
					}
				});
			}
		});
    });

});
